import helper from "actions/helper";

export default function ReportDaily(selectedStartDate, selectedEndDate, info, viewTable) {
    const style = [{
        name: "wrapText",
        start: [1, 1],
        end: [1, 1]
    }, {
        name: "bold",
        start: [1, 1],
        end: [1, 8]
    }];

    const width = [
        { key: 'A', width: 40 },
    ];

    const merges = [
        { start: [1, 1], end: [1, 4] },
        { start: [2, 1], end: [2, 4] },
    ];

    const period = selectedEndDate ?
        `${helper.date.toStr(selectedStartDate, "DD MMMM YYYY")} - ${helper.date.toStr(selectedEndDate, "DD MMMM YYYY")}` :
        helper.date.toStr(selectedStartDate, "DD MMMM YYYY");

    let text = [
        [`Дневной отчет за ${period} г.`],
        [`Отчет сформирован ${helper.date.toStr(new Date(), "DD MMMM YYYY")} г. в ${helper.date.toStr(new Date(), "HH mm")}`],
        ["", "", "", ""],
        ["", "", "", ""]
    ];

    if (selectedEndDate) {
        if (viewTable === "accounts") {
            const header = ["Счета и финансы"];

            const data = [
                ["Сумма выставленных счетов"],
                ["Общий приход средств за день"],
                ["Количество выставленных счетов"],
                ["Количество аннулированных счетов"],
                ["Оплачено по выставленным за день"],
                ["Долг за день"],
                ["Аванс за день"],
                ["Погашение долга за прошлые даты"],
                ["Сумма расходов за день"],
                ["Итого за день"],
            ];

            Object.keys(info).forEach(it => {
                header.push(helper.date.toStr(new Date(it), "DD MM"));
                data[0].push(info[it].invoicesAmount);
                data[1].push(info[it].totalDebt);
                data[2].push(info[it].invoicesCount);
                data[3].push(info[it].totalRefund);
                data[4].push(info[it].totalPaid);
                data[5].push(info[it].totalDuty);
                data[6].push(info[it].balance);
                data[7].push(info[it].amortizationPaid);
                data[8].push(info[it].totalExpenses);
                data[9].push(info[it].total);
            });
            style.push({
                name: "bold",
                start: [5, 1],
                end: [5, header.length]
            });
            style.push({
                name: "border",
                start: [5, 1],
                end: [15, header.length]
            });

            text = [
                ...text,
                header,
                ...data
            ];
        } else if (viewTable === "totalReceipt" || viewTable === "payers" || viewTable.includes("fund")) {
            style.push({
                name: "bold",
                start: [5, 1],
                end: [5, 1]
            });
            style.push({
                name: "border",
                start: [5, 1],
                end: [6 + info.length, 2]
            });

            const data = [];
            const header = ["Канал движения средств"];

            Object.keys(info).forEach(it => {
                header.push(helper.date.toStr(new Date(it), "DD MM"));

                info[it].forEach(canal => {
                    const ind = data.findIndex(row => row[0] === canal.entityTitle);
                    if (ind === -1)
                        data.push([canal.entityTitle]);
                });
            });

            const itog = [];
            Object.keys(info).forEach(it => {
                let sum = 0;
                data.forEach(row => {
                    const elem = info[it].find(canal => canal.entityTitle === row[0]);
                    if (elem) {
                        row.push(elem.value);
                        sum += +elem.value;
                    } else {
                        row.push(0);
                    }
                });
                itog.push(sum);
            });

            data.push(["Итого", ...itog]);

            style.push({
                name: "bold",
                start: [5, 1],
                end: [5, header.length]
            });
            style.push({
                name: "bold",
                start: [5 + data.length, 1],
                end: [5 + data.length, header.length]
            });
            style.push({
                name: "border",
                start: [5, 1],
                end: [5 + data.length, header.length]
            });

            text = [
                ...text,
                header,
                ...data
            ];
        }

    } else if (viewTable === "accounts") {
        merges.push({ start: [5, 1], end: [5, 2] });
        merges.push({ start: [5, 3], end: [5, 4] });
        width.push({ key: 'B', width: 10 });
        width.push({ key: 'C', width: 50 });
        style.push({
            name: "bold",
            start: [5, 1],
            end: [5, 4]
        });
        style.push({
            name: "border",
            start: [5, 1],
            end: [15, 4]
        });
        text = [
            ...text,
            ["Счета и финансы", "", "Визиты", ""],
            ["Сумма выставленных счетов", info.invoicesAmount, "Всего визитов", info.data2.visitsCount],
            ["Общий приход средств за день", info.totalDebt, "Количество новых пациентов", info.data2.newClientsCount],
            ["Количество выставленных счетов", info.invoicesCount, "Количество первичных пациентов, ставших пациентами", info.data2.primaryTookPlace],
            ["Количество аннулированных счетов", info.totalRefund, "Средняя загрузка врачей", info.data2.doctorsLoading],
            ["Оплачено по выставленным за день", info.totalPaid, "Средняя загрузка кресел", info.data2.doctorsLoading],
            ["Долг за день", info.totalDuty, "", ""],
            ["Аванс за день", info.balance, "", ""],
            ["Погашение долга за прошлые даты", info.amortizationPaid, "", ""],
            ["Сумма расходов за день", info.totalExpenses, "", ""],
            ["Итого за день", info.total, "", ""],
        ];
    } else if (viewTable === "totalReceipt" || viewTable === "payers" || viewTable.includes("fund")) {
        style.push({
            name: "bold",
            start: [5, 1],
            end: [5, 1]
        });
        style.push({
            name: "border",
            start: [5, 1],
            end: [6 + info.length, 2]
        },);
        text = [
            ...text,
            ["Канал движения средств", ""],
        ];
        let sum = 0;
        info.forEach(it => {
            const { entityTitle, value } = it;
            text.push([entityTitle, value]);
            sum += +value;
        });
        text.push(["Итого", sum]);
    } else if (viewTable === "payers") {
        console.log("payers");
    }

    const data = { text, style, width, merges };
    helper.xlsx.exportToExcel(data, "ReportDaily.xlsx");
}
